/* B26 Cart — panier animé Bled Eleven (tiroir + page panier).
   Le moteur du thème (theme.CartDrawer / theme.CartForm) reconstruit [data-products] via /cart?view=ajax.
   Ce script observe ces reconstructions et ajoute : paliers -10/-15/-20 %, total animé, retrait + annuler,
   ajout rapide (même famille que le panier : collection pays, sinon recommandations + best-sellers),
   barre de livraison, effets. */
(function () {
  'use strict';
  if (window.__b26k) return;
  window.__b26k = 1;

  var doc = document;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var NB = ' ';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var TIERS = [[2, 10, 'Duo'], [3, 15, 'Trio'], [4, 20, 'Pack Famille']];
  var D = null;

  /* ---------- outils ---------- */
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  function reduced() { return !!(mq && mq.matches); }
  function int(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function emit(name, detail) { doc.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) {
    c = Math.round(Number(c) || 0);
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(c, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return (c / 100).toFixed(2).replace('.', ',') + NB + '€';
  }
  function restart(el, cls, ms) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    if (ms) {
      clearTimeout(el['_b26k' + cls]);
      el['_b26k' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms);
    }
  }
  function post(path, body) {
    return fetch(ROOT + path, { method: 'POST', credentials: 'same-origin', headers: HEADERS, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  /* Recharge le panier du thème (cart:build) et prévient les autres scripts (cart:updated). */
  function refresh() {
    var asked = Date.now();
    emit('cart:build');
    /* filet : si la reconstruction du thème n'arrive pas (réseau), on la redemande une fois */
    setTimeout(function () { if (D && D.rebuiltAt < asked) emit('cart:build'); }, 2500);
    return getCart().then(function (cart) { emit('cart:updated', { cart: cart }); return cart; }).catch(function () {});
  }
  function img(u, w) {
    u = String(u || '');
    if (!u) return '';
    /* cdn.shopify.com/s/files/1/…/files/x.jpg -> /cdn/shop/files/x.jpg (même domaine, comme image_url) */
    u = u.replace(/^(?:https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\/(files|products)\//, '/cdn/shop/$1/');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    u = u.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* Même découpage que snippets/cart-item.liquid */
  function splitTitle(t) {
    t = String(t || '').split(' | ')[0].trim();
    var a = t.indexOf('«'), b = t.lastIndexOf('»');
    if (a < 0 || b < a) {
      var seps = [' — ', ' – ', ' - '];
      for (var i = 0; i < seps.length; i++) {
        var k = t.indexOf(seps[i]);
        if (k > 0) return { name: t.slice(0, k).trim(), sub: t.slice(k + seps[i].length).trim() };
      }
      return { name: t, sub: '' };
    }
    var before = t.slice(0, a).trim();
    var after = t.slice(b + 1).replace(/^\s*[–—-]\s*/, '').trim();
    return { name: t.slice(a + 1, b).trim(), sub: [before, after].filter(Boolean).join(' · ') };
  }
  function addBiz(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate()), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d;
  }
  function fmt(d, o) {
    try { return new Intl.DateTimeFormat('fr-FR', o).format(d); } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  /* ---------- paliers ---------- */
  function tierOf(n) { var t = 0; for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i][0]) t = i + 1; return t; }
  function ladderMsg(n) {
    if (n >= 4) return '<b>Pack Famille' + NB + ': -20' + NB + '% débloqué.</b> C’est le max' + NB + '!';
    if (n === 3) return '<b>Trio' + NB + ': -15' + NB + '% débloqué.</b> Encore 1 article pour -20' + NB + '%.';
    if (n === 2) return '<b>Duo' + NB + ': -10' + NB + '% débloqué.</b> Encore 1 article pour -15' + NB + '%.';
    if (n === 1) return 'Ajoute 1 article et débloque <b>-10' + NB + '%</b>.';
    return 'Dès 2 articles' + NB + ': <b>-10' + NB + '%</b> automatique.';
  }

  /* ---------- toast (annuler / infos) ---------- */
  function showToast(t, html, opts) {
    if (!t) return;
    opts = opts || {};
    var txt = $('[data-b26k-toast-txt]', t), btn = $('[data-b26k-undo]', t);
    txt.innerHTML = html;
    t.classList.toggle('b26k-toast--win', !!opts.win);
    btn.hidden = !opts.undo;
    btn.disabled = false;
    t._undo = opts.undo || null;
    var dur = opts.undo ? 6000 : 3200;
    t.style.setProperty('--t', dur + 'ms');
    t.hidden = false;
    restart(t, 'is-in');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { hideToast(t); }, dur);
    if (opts.undo && opts.focus) { try { btn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function hideToast(t) {
    if (!t) return;
    clearTimeout(t._timer);
    t.classList.remove('is-in');
    t._undo = null;
    setTimeout(function () { if (!t.classList.contains('is-in')) t.hidden = true; }, 380);
  }
  function bindToast(t) {
    on(t, 'click', function (e) {
      var b = e.target.closest('[data-b26k-undo]');
      if (!b || !t._undo) return;
      var line = t._undo;
      t._undo = null;
      b.disabled = true;
      post('cart/add.js', { items: [line] })
        .then(function () { hideToast(t); refresh(); announce('Article remis dans le panier.'); })
        .catch(function (er) { showToast(t, esc((er && er.description) || 'Impossible de remettre l’article.')); });
    });
  }
  function pageToast() {
    var t = $('.b26k-toast--page');
    if (!t) {
      t = doc.createElement('div');
      t.className = 'b26k-toast b26k-toast--page';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.hidden = true;
      t.innerHTML = '<span class="b26k-toast__txt" data-b26k-toast-txt></span><button type="button" class="b26k-toast__btn" data-b26k-undo hidden>Annuler</button><i class="b26k-toast__bar"></i>';
      doc.body.appendChild(t);
      bindToast(t);
    }
    return t;
  }
  function announce(text) {
    var live = D && D.live;
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }

  /* ---------- retrait d'une ligne (+ annuler) ---------- */
  function collapse(el) {
    return new Promise(function (resolve) {
      if (reduced() || !el.animate) { el.style.display = 'none'; resolve(); return; }
      var cs = getComputedStyle(el), h = el.offsetHeight, done = false;
      el.style.overflow = 'hidden';
      var a = el.animate([
        { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, borderBottomWidth: cs.borderBottomWidth, opacity: 1, transform: 'translateX(0)' },
        { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, borderBottomWidth: cs.borderBottomWidth, opacity: 0, transform: 'translateX(48px)', offset: 0.42 },
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderBottomWidth: '0px', opacity: 0, transform: 'translateX(48px)' }
      ], { duration: 560, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
      function fin() { if (!done) { done = true; resolve(); } }
      a.onfinish = fin;
      setTimeout(fin, 800);
    });
  }
  function uncollapse(el) {
    el.style.display = '';
    el.style.overflow = '';
    if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); });
  }
  function removeLine(item, ctx) {
    if (item.classList.contains('is-removing')) return;
    item.classList.add('is-removing');
    var line = { id: int(item.getAttribute('data-variant-id')), quantity: int(item.getAttribute('data-qty')) || 1 };
    var props = item.getAttribute('data-props');
    if (props) { try { var p = JSON.parse(props); if (p && typeof p === 'object' && Object.keys(p).length) line.properties = p; } catch (e) {} }
    var plan = int(item.getAttribute('data-plan'));
    if (plan) line.selling_plan = plan;
    var name = item.getAttribute('data-name') || 'Article';
    var hadFocus = item.contains(doc.activeElement);
    Promise.all([post('cart/change.js', { id: item.getAttribute('data-key'), quantity: 0 }), collapse(item)])
      .then(function (res) {
        var cart = res[0];
        emit('cart:build');
        emit('cart:updated', { cart: cart });
        announce(name + ' retiré du panier.');
        if (ctx.afterRemove && ctx.afterRemove(cart) === false) return;
        showToast(ctx.toast(), '<b>' + esc(name) + '</b> retiré.', { undo: line.id ? line : null, focus: hadFocus });
      })
      .catch(function () {
        item.classList.remove('is-removing');
        uncollapse(item);
        emit('cart:build');
      });
  }
  /* Capture : le « − » à 1 et la corbeille passent par notre retrait animé (avec annuler).
     Le reste (+, − au-dessus de 1, saisie) reste géré par le thème. */
  function lineClick(e, ctx) {
    var t = e.target;
    if (!t || !t.closest) return;
    var rm = t.closest('[data-b26k-remove]');
    var minus = rm ? null : t.closest('.js-qty__adjust--minus');
    var btn = rm || minus;
    var item = btn && btn.closest('.b26k-item');
    if (!item) return;
    if (minus) {
      var input = $('.js-qty__num', item);
      var q = int(input && input.value);
      if (q === null || q > 1) return;
    }
    e.preventDefault();
    e.stopPropagation();
    removeLine(item, ctx);
  }
  function lineChange(e, ctx) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('js-qty__num')) return;
    var item = input.closest('.b26k-item');
    if (!item || String(input.value).trim() !== '0') return;
    e.stopPropagation();
    input.value = item.getAttribute('data-qty') || '1';
    removeLine(item, ctx);
  }

  /* ---------- données d'ajout rapide ---------- */
  var mem = {};
  function cents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'number') return v;
    v = String(v);
    return v.indexOf('.') > -1 ? Math.round(parseFloat(v) * 100) : (int(v) || 0);
  }
  function normalize(p) {
    if (!p || !p.id || !p.handle) return null;
    var opts = (p.options || []).map(function (o, i) {
      return { name: (o && o.name) || String(o || ''), values: (o && o.values) || [], i: i };
    });
    var vs = (p.variants || []).map(function (v) {
      return { id: v.id, ok: v.available !== false, price: cents(v.price), was: cents(v.compare_at_price), o: [v.option1, v.option2, v.option3] };
    });
    if (!vs.length) return null;
    var pic = p.featured_image;
    if (pic && typeof pic === 'object') pic = pic.src;
    if (!pic && p.images && p.images.length) pic = p.images[0].src || p.images[0];
    var multi = opts.filter(function (o) { return o.values.length > 1; });
    var mode = vs.length === 1 ? 'one' : (multi.length === 1 && multi[0].values.length <= 8 ? 'chips' : 'link');
    var chips = [];
    if (mode === 'chips') {
      var oi = multi[0].i;
      multi[0].values.forEach(function (val) {
        for (var k = 0; k < vs.length; k++) {
          if (vs[k].o[oi] === val) {
            chips.push({ id: vs[k].id, ok: vs[k].ok, label: String(val).replace(/^(\d)\s+XL$/i, '$1XL') });
            return;
          }
        }
      });
    }
    var first = vs.filter(function (v) { return v.ok; })[0] || vs[0];
    var tt = splitTitle(p.title);
    /* ligne (tag collection:xxx) et public (audience:xxx) : servent à ordonner la famille */
    var line = p.line || '', aud = p.aud || '';
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(/\s*,\s*/);
    tags.forEach(function (t) {
      t = String(t);
      if (!line && t.indexOf('collection:') === 0) line = t.slice(11);
      else if (!aud && /^audience:(femme|homme|enfant|unisexe)$/.test(t)) aud = t.slice(9);
    });
    return {
      id: p.id, url: ROOT + 'products/' + p.handle, name: tt.name, sub: tt.sub, img: pic ? String(pic) : '',
      price: first.price, was: first.was > first.price ? first.was : 0,
      ok: vs.some(function (v) { return v.ok; }), mode: mode, chips: chips, one: first.id,
      opt: multi[0] ? multi[0].name : '', line: line, aud: aud
    };
  }
  function fetchList(path) {
    if (mem[path]) return mem[path];
    var key = 'b26k:' + path, hit = null;
    try { hit = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
    if (hit && hit.v === 2 && Date.now() - hit.t < 9e5 && hit.list) {
      mem[path] = Promise.resolve(hit.list);
      return mem[path];
    }
    /* pas d'en-tête Accept: application/json : sinon Shopify renvoie l'objet collection brut au lieu de ?view=b26k */
    mem[path] = fetch(ROOT + path, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        var list = (d.products || []).map(normalize).filter(Boolean);
        try { sessionStorage.setItem(key, JSON.stringify({ v: 2, t: Date.now(), list: list })); } catch (e) {}
        return list;
      })
      .catch(function () { delete mem[path]; return []; });
    return mem[path];
  }

  /* =====================================================================
     Tiroir
     ===================================================================== */
  function initDrawer() {
    var root = doc.getElementById('CartDrawer');
    if (!root || !root.hasAttribute('data-b26k')) return;
    var form = $('#CartDrawerForm', root);
    D = {
      root: root, form: form,
      count: $('[data-b26k-count]', root),
      ladder: $('[data-b26k-ladder]', root),
      msg: $('[data-b26k-ladder-msg]', root),
      segs: $$('.b26k-seg', root),
      body: $('[data-b26k-body]', root),
      ship: $('[data-b26k-ship]', root),
      eta: $('[data-b26k-eta]', root),
      products: $('[data-products]', root),
      empty: $('.b26k-empty', root),
      rail: $('[data-b26k-rail]', root),
      railTitle: $('[data-b26k-rail-title]', root),
      track: $('[data-b26k-track]', root),
      foot: $('[data-b26k-foot]', root),
      total: $('[data-b26k-total]', root),
      orig: $('[data-b26k-orig]', root),
      save: $('[data-b26k-save]', root),
      saveAmt: $('[data-b26k-save-amt]', root),
      cta: $('.b26k-cta', root),
      toast: $('[data-b26k-toast]', root),
      live: $('[data-b26k-live]', root),
      open: root.classList.contains('drawer--is-open'),
      isEmpty: root.classList.contains('is-empty'),
      ready: false, pending: false, railInit: false, anchor: null, railSeq: 0, railTimer: 0,
      qty: {},
      elig: D_int(root),
      lastTotal: null, lastDisc: 0, rebuiltAt: 0
    };
    if (D.total) D.lastTotal = int(D.total.getAttribute('data-cents'));
    if (D.ladder) D.msgKey = Math.min(D.elig || 0, 4);
    if (!form || !D.products) return;

    var ctx = { toast: function () { return D.toast; } };
    on(form, 'click', function (e) { lineClick(e, ctx); }, true);
    on(form, 'change', function (e) { lineChange(e, ctx); }, true);
    bindToast(D.toast);
    on(D.track, 'click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('[data-b26k-open]');
      if (opener) { e.preventDefault(); toggleCard(opener.closest('.b26k-card')); return; }
      var closer = t.closest('[data-b26k-close]');
      if (closer) { e.preventDefault(); closeCards(null); return; }
      var b = t.closest('[data-b26k-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      quickAdd(b);
    });
    on(form, 'click', function (e) {
      if (!e.target.closest || !e.target.closest('.b26k-card')) closeCards(null);
    });
    /* Échap referme d'abord le choix de taille (le thème ferme le tiroir sur keyup) */
    on(root, 'keyup', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && $('.b26k-card.is-open', D.track)) { e.stopPropagation(); closeCards(null); }
    });
    /* Flèches du rail (souris) */
    D.navs = $$('[data-b26k-nav]', root);
    D.navs.forEach(function (b) {
      on(b, 'click', function () {
        var card = $('.b26k-card', D.track);
        var step = card ? (card.offsetWidth + 10) * 2 : 300;
        D.track.scrollBy({ left: step * int(b.getAttribute('data-b26k-nav')), behavior: reduced() ? 'auto' : 'smooth' });
      });
    });
    on(D.track, 'scroll', function () {
      if (D.navT) return;
      D.navT = requestAnimationFrame(function () { D.navT = 0; railNav(); });
    }, { passive: true });

    new MutationObserver(onRebuild).observe(D.products, { childList: true });
    new MutationObserver(function () {
      var open = root.classList.contains('drawer--is-open');
      var empty = root.classList.contains('is-empty');
      if (open && !D.open) { D.open = true; onOpen(); }
      else if (!open && D.open) { D.open = false; onClose(); }
      if (empty !== D.isEmpty) { D.isEmpty = empty; onEmptyChange(empty); }
    }).observe(root, { attributes: true, attributeFilter: ['class'] });

    if (window.ResizeObserver && D.foot) {
      new ResizeObserver(function () { form.style.setProperty('--b26k-foot-h', D.foot.offsetHeight + 'px'); }).observe(D.foot);
    }
    on(doc, 'ajaxProduct:added', function () { D.pending = true; });
    if (D.open) onOpen();
  }
  function D_int(root) {
    var l = $('[data-b26k-ladder]', root);
    return l ? (int(l.getAttribute('data-eligible')) || 0) : 0;
  }

  function onRebuild() {
    var list = $('.cart__items', D.products);
    var items = $$('.b26k-item', D.products);
    var d = list ? list.dataset : {};
    var count = int(d.count);
    if (count === null) count = items.reduce(function (n, el) { return n + (int(el.getAttribute('data-qty')) || 0); }, 0);
    var elig = int(d.eligible);
    if (elig === null) elig = items.reduce(function (n, el) { return n + (el.getAttribute('data-eligible') === '1' ? (int(el.getAttribute('data-qty')) || 0) : 0); }, 0);
    var total = int(d.cartSubtotal) || 0;
    var disc = int(d.cartDiscount) || 0;
    var orig = int(d.cartOriginal);
    if (orig === null) orig = total + disc;

    var anim = D.ready && !reduced();
    var prev = D.qty, next = {};
    items.forEach(function (el, i) {
      var k = lineId(el), q = int(el.getAttribute('data-qty')) || 0;
      next[k] = q;
      el.style.setProperty('--i', Math.min(i, 6));
      if (!anim) return;
      if (!(k in prev)) restart(el, 'is-new', 1500);
      else if (prev[k] !== q) el.classList.add(q > prev[k] ? 'is-up' : 'is-down');
    });
    D.qty = next;

    setCount(count, anim);
    setLadder(elig, anim);
    setTotals(total, orig, disc, anim);
    D.ready = true;
    D.pending = false;
    D.rebuiltAt = Date.now();
    if (D.open) {
      if (!D.railInit) initRail();
      else scheduleRail();
    }
  }

  /* La clé Shopify d'une ligne change dès que la quantité ou la remise change : on suit variante + options. */
  function lineId(el) {
    return [el.getAttribute('data-variant-id'), el.getAttribute('data-props') || '', el.getAttribute('data-plan') || ''].join('|');
  }

  function setCount(n, anim) {
    if (!D.count) return;
    if (String(n) === D.count.textContent.trim()) return;
    D.count.textContent = n;
    D.count.setAttribute('aria-label', n + (n > 1 ? ' articles' : ' article'));
    if (anim) restart(D.count, 'is-bump', 700);
  }

  function paintSegs(n) {
    D.segs.forEach(function (s, i) {
      s.classList.toggle('is-on', n >= i + 1);
      s.classList.toggle('is-next', n === i && n < D.segs.length);
    });
    if (D.ladder) D.ladder.classList.toggle('is-max', n >= D.segs.length);
  }
  function setLadder(n, anim) {
    if (!D.ladder) return;
    var prev = D.elig || 0;
    D.elig = n;
    paintSegs(n);
    var key = Math.min(n, 4);
    if (key !== D.msgKey) {
      D.msgKey = key;
      D.msg.innerHTML = ladderMsg(n);
      if (anim) restart(D.msg, 'is-swap', 600);
    }
    var t0 = tierOf(prev), t1 = tierOf(n);
    if (anim && t1 > t0) unlock(t1);
  }
  function replayLadder() {
    if (!D.ladder || !D.segs.length) return;
    D.ladder.classList.add('is-reset');
    D.segs.forEach(function (s) { s.classList.remove('is-on'); });
    void D.ladder.offsetWidth;
    D.ladder.classList.remove('is-reset');
    requestAnimationFrame(function () { requestAnimationFrame(function () { paintSegs(D.elig || 0); }); });
  }
  function unlock(t) {
    var tier = TIERS[t - 1];
    var seg = D.segs[tier[0] - 1];
    if (seg) restart(seg, 'is-pop', 800);
    burst(D.ladder, seg);
    announce(tier[2] + ' débloqué : -' + tier[1] + ' % sur tes articles.');
    /* barre des paliers hors écran (on est descendu vers l'ajout rapide) : on prévient quand même */
    if (D.open && D.body && D.ladder) {
      var br = D.body.getBoundingClientRect(), lr = D.ladder.getBoundingClientRect();
      if (lr.bottom < br.top + 10 || lr.top > br.bottom) {
        showToast(D.toast, '<b>' + esc(tier[2]) + ' débloqué' + NB + '!</b> -' + tier[1] + NB + '% sur tes articles.', { win: true });
      }
    }
  }
  function burst(box, anchor) {
    if (reduced() || !box || !anchor || !D.open) return;
    var br = box.getBoundingClientRect(), ar = anchor.getBoundingClientRect();
    var b = doc.createElement('span');
    b.className = 'b26k-burst';
    b.style.left = (ar.right - br.left - 14) + 'px';
    b.style.top = (ar.top - br.top + 16) + 'px';
    var colors = ['#d8ff00', '#ffffff', '#b9e000', '#d8ff00'];
    for (var i = 0; i < 18; i++) {
      var ang = (Math.PI * 2 * i) / 18 + Math.random() * 0.35;
      var dist = 26 + Math.random() * 38;
      var p = doc.createElement('i');
      p.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(1) + 'px');
      p.style.setProperty('--dy', (Math.sin(ang) * dist - 12).toFixed(1) + 'px');
      p.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
      p.style.setProperty('--c', colors[i % colors.length]);
      p.style.animationDelay = Math.round(Math.random() * 70) + 'ms';
      b.appendChild(p);
    }
    box.appendChild(b);
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 1300);
  }

  function setTotals(total, orig, disc, anim) {
    roll(D.total, D.lastTotal, total, anim);
    D.lastTotal = total;
    var has = disc > 0;
    if (D.orig) { D.orig.hidden = !has; if (has) D.orig.textContent = money(orig); }
    if (D.save) {
      var was = !D.save.hidden;
      D.save.hidden = !has;
      if (has) {
        D.saveAmt.textContent = money(disc);
        if (anim && (!was || D.lastDisc !== disc)) restart(D.save, 'is-pop', 700);
      }
    }
    if (anim && total !== D.shineTotal) restart(D.cta, 'is-shine', 1400);
    D.shineTotal = total;
    D.lastDisc = disc;
  }
  function roll(el, from, to, anim) {
    if (!el) return;
    if (el._raf) cancelAnimationFrame(el._raf);
    if (!anim || from == null || from === to) { el.textContent = money(to); el.classList.remove('is-rolling'); return; }
    var t0 = null, dur = 650;
    el.classList.add('is-rolling');
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = money(from + (to - from) * e);
      if (p < 1) el._raf = requestAnimationFrame(step);
      else { el._raf = 0; el.textContent = money(to); el.classList.remove('is-rolling'); }
    }
    el._raf = requestAnimationFrame(step);
  }

  function renderEta() {
    if (!D.eta) return;
    var now = new Date(), a = addBiz(now, 5), b = addBiz(now, 8);
    var sameMonth = a.getMonth() === b.getMonth();
    D.eta.textContent = 'du ' + fmt(a, sameMonth ? { day: 'numeric' } : { day: 'numeric', month: 'short' }) +
      ' au ' + fmt(b, { day: 'numeric', month: 'short' });
  }

  function mountWallets() {
    $$('[data-b26-wallets]', D.root).forEach(function (box) {
      var tpl = box.querySelector('template');
      if (!tpl || !tpl.content) return;
      var frag = tpl.content.cloneNode(true);
      $$('script', frag).forEach(function (old) {
        var s = doc.createElement('script');
        Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
        s.text = old.text;
        old.parentNode.replaceChild(s, old);
      });
      tpl.parentNode.removeChild(tpl);
      box.appendChild(frag);
    });
  }

  function onOpen() {
    renderEta();
    if (D.body) D.body.scrollTop = 0;
    if (D.track) D.track.scrollLeft = 0;
    if (!reduced()) {
      restart(D.root, 'is-entering', 1500);
      replayLadder();
      restart(D.ship, 'is-drive');
      clearTimeout(D.shineT);
      D.shineT = setTimeout(function () { restart(D.cta, 'is-shine', 1400); }, 700);
    }
    D.railInit = false;
    if (!D.pending) initRail();
    else {
      clearTimeout(D.pendT);
      D.pendT = setTimeout(function () { if (D.open && !D.railInit) initRail(); }, 1500);
    }
    /* b26-core monte normalement Apple Pay / PayPal à l'ouverture ; filet de sécurité */
    setTimeout(mountWallets, 60);
  }
  function onClose() {
    hideToast(D.toast);
    clearTimeout(D.railTimer);
    if (D.track) closeCards(null);
  }
  function onEmptyChange(empty) {
    if (empty) { D.anchor = null; D.railInit = false; }
    if (!D.open || reduced()) return;
    if (empty) {
      restart(D.empty, 'is-appear', 700);
    } else {
      restart(D.ladder, 'is-appear', 700);
      restart(D.ship, 'is-appear', 700);
      restart(D.foot, 'is-appear', 700);
    }
  }

  /* ---------- ajout rapide ---------- */
  function initRail() {
    D.railInit = true;
    var first = $('.b26k-item', D.products);
    D.anchor = first ? first.getAttribute('data-product-id') : null;
    loadRail(true);
  }
  function scheduleRail() {
    clearTimeout(D.railTimer);
    D.railTimer = setTimeout(function () { loadRail(false); }, 750);
  }
  /* Suggestions = même famille que le panier : la collection pays du produit (data-fam, ex. algerie).
     La Petite Algérienne -> Le Petit Algérien, puis les versions Enfant, puis le reste de la collection (Passeport…).
     Famille du dernier produit ouvert d'abord (ancre), puis celles des autres lignes.
     S'il ne reste rien dans la famille : recommandations Shopify + best-sellers (comme avant). */
  var PAIR = { femme: ['homme', 'enfant'], homme: ['femme', 'enfant'], enfant: ['femme', 'homme', 'enfant'] };
  function famRefs(items) {
    var refs = [], seen = {};
    var anchor = D.anchor ? items.filter(function (el) { return el.getAttribute('data-product-id') === D.anchor; }) : [];
    anchor.concat(items).forEach(function (el) {
      var f = el.getAttribute('data-fam');
      if (!f || seen[f]) return;
      seen[f] = 1;
      refs.push({ fam: f, line: el.getAttribute('data-line') || '', aud: el.getAttribute('data-aud') || '' });
    });
    return refs.slice(0, 3);
  }
  function rankFam(list, ref) {
    var pref = PAIR[ref.aud] || [];
    return list.map(function (p, i) {
      var other = ref.line && p.line === ref.line ? 0 : 1;
      var a = pref.indexOf(p.aud);
      return { p: p, x: other, y: other ? 0 : (a < 0 ? 9 : a), z: i };
    }).sort(function (m, n) { return m.x - n.x || m.y - n.y || m.z - n.z; }).map(function (m) { return m.p; });
  }
  function loadRail(fresh) {
    if (!D.rail || !D.track) return;
    var items = $$('.b26k-item', D.products);
    var inCart = {};
    items.forEach(function (el) { inCart[el.getAttribute('data-product-id')] = 1; });
    var empty = !items.length;
    if (!D.anchor && items.length) D.anchor = items[0].getAttribute('data-product-id');
    var seq = ++D.railSeq;
    var refs = famRefs(items);
    function pick(lists, ranked) {
      var seen = {}, out = [];
      function take(p) {
        if (out.length >= 8 || !p || !p.ok || seen[p.id] || inCart[p.id]) return;
        seen[p.id] = 1;
        out.push(p);
      }
      if (!ranked) { lists.forEach(function (list) { list.forEach(take); }); return out; }
      var sorted = lists.map(function (list, k) { return rankFam(list, refs[k]); });
      /* 1) la même ligne (ex. Le Petit / La Petite) de chaque famille du panier, 2) le reste de leurs collections */
      sorted.forEach(function (list, k) { list.forEach(function (p) { if (refs[k].line && p.line === refs[k].line) take(p); }); });
      sorted.forEach(function (list) { list.forEach(take); });
      return out;
    }
    function classic() {
      var jobs = [];
      if (D.anchor) jobs.push(fetchList('recommendations/products.json?product_id=' + encodeURIComponent(D.anchor) + '&limit=10&intent=related'));
      jobs.push(fetchList('collections/nos-best-sellers/products.json?limit=12'));
      return Promise.all(jobs).then(function (lists) { return pick(lists, false); });
    }
    var go = refs.length
      ? Promise.all(refs.map(function (r) { return fetchList('collections/' + encodeURIComponent(r.fam) + '?view=b26k'); }))
          .then(function (lists) { var out = pick(lists, true); return out.length ? out : classic(); })
      : classic();
    go.then(function (out) {
      if (seq !== D.railSeq) return;
      renderRail(out, empty, fresh);
    });
  }
  var PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  /* « T-shirt Maroc · Femme » -> « Femme » (utile pour distinguer Femme / Homme / Enfant) */
  function tagOf(sub) {
    var last = String(sub || '').split(' · ').pop();
    return /^(femme|homme|enfant|unisexe|b[ée]b[ée])$/i.test(last) ? last : '';
  }
  function cardHTML(p, i) {
    var name = esc(p.name), url = esc(p.url), plus, sizes = '';
    if (p.mode === 'chips') {
      var cols = p.chips.every(function (c) { return String(c.label).length <= 3; }) ? 3 : 2;
      var rows = Math.ceil(p.chips.length / cols);
      plus = '<button type="button" class="b26k-card__plus" data-b26k-open aria-expanded="false" aria-label="Ajouter ' + name + ' : choisir la taille">' + PLUS + '</button>';
      sizes = '<div class="b26k-card__sizes" role="group" aria-label="Choisis ta taille : ' + name + '" style="--cols:' + cols + ';--ch:' + (rows >= 4 ? 23 : 28) + 'px">' +
        '<div class="b26k-card__top"><span class="b26k-card__pick">Ta taille</span><button type="button" class="b26k-card__x" data-b26k-close aria-label="Fermer">' + CROSS + '</button></div>' +
        '<div class="b26k-card__grid">' + p.chips.map(function (c) {
          return '<button type="button" class="b26k-chip" data-b26k-add="' + c.id + '"' + (c.ok ? '' : ' disabled') +
            ' aria-label="' + esc(p.opt || 'Taille') + ' ' + esc(c.label) + '">' + esc(c.label) + '</button>';
        }).join('') + '</div>' +
      '</div>';
    } else if (p.mode === 'one') {
      plus = '<button type="button" class="b26k-card__plus" data-b26k-add="' + p.one + '" aria-label="Ajouter ' + name + ' au panier">' + PLUS + '</button>';
    } else {
      plus = '<a class="b26k-card__plus" href="' + url + '" aria-label="Voir ' + name + '">' + PLUS + '</a>';
    }
    var pic = p.img ? '<img src="' + esc(img(p.img, 240)) + '" srcset="' + esc(img(p.img, 120)) + ' 120w, ' + esc(img(p.img, 240)) + ' 240w, ' + esc(img(p.img, 360)) + ' 360w" sizes="118px" alt="" loading="lazy" width="118" height="118">' : '';
    var tag = tagOf(p.sub);
    return '<div class="b26k-card" role="listitem" data-pid="' + p.id + '" style="--i:' + (i || 0) + '">' +
      '<div class="b26k-card__media"><a class="b26k-card__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + pic + '</a>' + plus + '</div>' +
      '<a class="b26k-card__name" href="' + url + '">' + name + '</a>' +
      '<p class="b26k-card__meta"><b>' + money(p.price) + '</b>' + (p.was ? '<s>' + money(p.was) + '</s>' : '') + (tag ? ' · ' + esc(tag) : '') + '</p>' +
      sizes +
      '<span class="b26k-card__ok" aria-hidden="true">Ajouté ✓</span>' +
    '</div>';
  }
  function closeCards(except) {
    $$('.b26k-card.is-open', D.track).forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-open');
      var b = $('[data-b26k-open]', c);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function toggleCard(card) {
    var open = !card.classList.contains('is-open');
    closeCards(card);
    card.classList.toggle('is-open', open);
    var b = $('[data-b26k-open]', card);
    if (b) b.setAttribute('aria-expanded', String(open));
    if (open) {
      var first = $('.b26k-chip:not([disabled])', card);
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
      /* carte partiellement cachée : on la ramène dans le rail */
      var tr = D.track.getBoundingClientRect(), cr = card.getBoundingClientRect();
      if (cr.right > tr.right - 4 || cr.left < tr.left + 4) {
        D.track.scrollBy({ left: cr.left - tr.left - 16, behavior: reduced() ? 'auto' : 'smooth' });
      }
    }
  }
  function renderRail(list, empty, fresh) {
    if (D.railTitle) D.railTitle.textContent = empty ? 'Nos best-sellers' : 'Complète ton bled';
    if (!list.length) { D.rail.hidden = true; D.track.innerHTML = ''; return; }
    var ids = list.map(function (p) { return String(p.id); });
    var live = $$('.b26k-card', D.track).filter(function (c) { return !c.classList.contains('is-leaving'); });
    var cur = live.map(function (c) { return c.getAttribute('data-pid'); });
    D.rail.hidden = false;
    if (cur.join() === ids.join()) return;
    var prefix = !fresh && cur.length > 0 && cur.every(function (id, k) { return ids[k] === id; });
    if (prefix) {
      list.slice(cur.length).forEach(function (p) {
        D.track.insertAdjacentHTML('beforeend', cardHTML(p, 0));
        if (!reduced()) restart(D.track.lastElementChild, 'is-joining', 700);
      });
      railNav();
      return;
    }
    D.track.innerHTML = list.map(cardHTML).join('');
    D.track.scrollLeft = 0;
    if (!reduced() && D.open) restart(D.track, 'is-in', 1500);
    railNav();
  }
  function railNav() {
    if (!D.navs || !D.navs.length || !D.track) return;
    var max = D.track.scrollWidth - D.track.clientWidth - 2;
    D.navs[0].disabled = D.track.scrollLeft <= 2;
    D.navs[1].disabled = D.track.scrollLeft >= max;
  }
  function quickAdd(btn) {
    var card = btn.closest('.b26k-card');
    if (!card || card.classList.contains('is-busy')) return;
    var nameEl = $('.b26k-card__name', card);
    var name = nameEl ? nameEl.textContent : 'Article';
    var old = $('.b26k-card__err', card);
    if (old) old.parentNode.removeChild(old);
    card.classList.add('is-busy');
    btn.classList.add('is-busy');
    post('cart/add.js', { items: [{ id: int(btn.getAttribute('data-b26k-add')), quantity: 1 }] })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        card.classList.add('is-added');
        setTimeout(function () { card.classList.remove('is-open'); }, 250);
        fly(card);
        bumpHeader();
        announce(name + ' ajouté au panier.');
        refresh();
        setTimeout(function () { leave(card); }, 1100);
      })
      .catch(function (er) {
        btn.classList.remove('is-busy');
        card.classList.remove('is-busy');
        var m = doc.createElement('p');
        m.className = 'b26k-card__err';
        m.textContent = (er && (er.description || er.message)) || 'Oups, réessaie.';
        card.classList.remove('is-open');
        var meta = $('.b26k-card__meta', card);
        if (meta) meta.insertAdjacentElement('afterend', m); else card.appendChild(m);
      });
  }
  function leave(card) {
    card.classList.add('is-leaving');
    function gone() {
      if (card.parentNode) card.parentNode.removeChild(card);
      if (!$('.b26k-card', D.track)) D.rail.hidden = true;
      railNav();
      scheduleRail();
    }
    if (reduced() || !card.animate) { gone(); return; }
    var w = card.offsetWidth;
    var a = card.animate([
      { opacity: 1, transform: 'scale(1)', flexBasis: w + 'px', marginRight: '0px' },
      { opacity: 0, transform: 'scale(.86)', flexBasis: w + 'px', marginRight: '0px', offset: 0.45 },
      { opacity: 0, transform: 'scale(.86)', flexBasis: '0px', marginRight: '-10px' }
    ], { duration: 580, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
    a.onfinish = gone;
  }
  function fly(card) {
    if (reduced()) return;
    var im = $('img', card), target = D.count;
    if (!im || !target || !im.animate) return;
    var a = im.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var c = im.cloneNode(false);
    c.removeAttribute('loading');
    c.className = 'b26k-fly';
    c.style.left = a.left + 'px';
    c.style.top = a.top + 'px';
    c.style.width = a.width + 'px';
    c.style.height = a.height + 'px';
    doc.body.appendChild(c);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var an = c.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.55).toFixed(1) + 'px,' + (dy * 0.55 - 70).toFixed(1) + 'px) scale(.55) rotate(-8deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(.12) rotate(6deg)', opacity: 0.35 }
    ], { duration: 760, easing: 'cubic-bezier(.55,0,.35,1)' });
    an.onfinish = function () { if (c.parentNode) c.parentNode.removeChild(c); restart(D.count, 'is-bump', 700); };
  }
  function bumpHeader() {
    $$('.site-header .cart-link').forEach(function (el) { restart(el, 'b26-bump', 700); });
  }

  /* =====================================================================
     Page panier (/cart) — mêmes lignes, retrait animé + annuler
     ===================================================================== */
  function initPage() {
    var form = doc.getElementById('CartPageForm');
    if (!form) return;
    var ctx = {
      toast: pageToast,
      afterRemove: function (cart) {
        if (cart && cart.item_count === 0) { setTimeout(function () { window.location.reload(); }, 250); return false; }
      }
    };
    on(form, 'click', function (e) { lineClick(e, ctx); }, true);
    on(form, 'change', function (e) { lineChange(e, ctx); }, true);
    var products = $('[data-products]', form);
    if (products) {
      new MutationObserver(function () {
        var l = $('.cart__items', products);
        if (l && l.getAttribute('data-count') === '0') window.location.reload();
      }).observe(products, { childList: true });
    }
  }

  function init() { initDrawer(); initPage(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})();
